import { ForwardedRef, forwardRef } from 'react';
import { tv } from '../../../utils/tv';
import { ButtonComponentInternal, ButtonComponentProps } from '../components';
import { Icon } from '../../../theme/icon';
import { ButtonStyleProps } from '../styles';

export type CalloutToggleType = 'alert' | 'question';

const style = tv({
  base: `
    rounded-full
    !p-0
    text-black

    hover:text-secondary
  `
});

type Props = Omit<
  ButtonComponentProps,
  ButtonStyleProps | 'className' | 'type'
> & {
  open?: boolean;
  type: CalloutToggleType;
};

const Component = (
  { open, type, ...props }: Props,
  ref: ForwardedRef<HTMLButtonElement>
) => {
  const icon = open
    ? 'showLessInfo'
    : type === 'alert'
      ? 'alert'
      : 'showMoreInfo';

  return (
    <ButtonComponentInternal
      {...props}
      className={style()}
      ref={ref}
      variant="borderless"
      size="small"
      alignment="left"
    >
      <Icon icon={icon} size="medium" />
    </ButtonComponentInternal>
  );
};

export const CalloutToggle = forwardRef(Component);
